import React, { useContext } from 'react';
import { FormContext, FormSchemaFields } from '@sw-sw/lib-form';
import { UIControlType } from '@sw-sw/lib-form-control-types';
import FormModal from '../../Shared/form/modal/FormModal';

const PublicInfoModal = ({ onSubmit, onCancel, onSkip, required = true, projectName, clientName }) => {
  const formContext = useContext(FormContext);

  const getSchema = () => ({
    name: {
      label: 'Name*',
      type: UIControlType.text,
      validation: { required: true },
      placeholder: 'Enter your name',
    },
    email: {
      label: 'Email*',
      type: UIControlType.email,
      validation: { format: 'email', required: true },
      placeholder: 'Enter your email',
    },
    company: {
      label: 'Company',
      type: UIControlType.text,
      placeholder: 'Enter your company (optional)',
    },
  });

  const handleSubmit = async () => {
    if (formContext.isValid) {
      await onSubmit({
        ...formContext.value,
        email: formContext.value.email?.trim().toLowerCase(),
        name: formContext.value.name?.trim(),
        company: formContext.value.company?.trim() || '',
      });
    }
  };

  return (
    <FormModal
      modalProps={{
        title: 'Welcome',
        subtitle: required
          ? 'Please provide your information to access this project'
          : 'Provide your information to access this project, or skip to continue anonymously',
        classes: 'visitor-info-modal',
      }}
      onSubmit={handleSubmit}
      onCancel={required ? onCancel : undefined}
      showCancel={required}
      submitText='Continue'
      submitDisabled={!formContext.isValid}
      cancelText='Cancel'
      actionChildren={!required && onSkip ? (
        <>
          <span style={{ alignSelf: 'center', fontSize: '0.875rem', color: '#666', marginRight: '4px' }}>
            You may skip directly to the public view page.
          </span>
          <button
            type='button'
            className='reversed form-action-secondary'
            onClick={onSkip}
          >
            Skip
          </button>
        </>
      ) : null}
    >
      {(clientName || projectName) && (
        <div style={{ display: 'flex', alignItems: 'baseline', gap: '8px', marginBottom: '16px' }}>
          {clientName && <span style={{ fontWeight: 600 }}>{clientName}</span>}
          {projectName && <span style={{ color: '#555' }}>{projectName}</span>}
        </div>
      )}
      <FormSchemaFields
        schema={getSchema()}
        formData={formContext.value}
        onChange={formContext.set}
        initialFormData={{}}
      />
    </FormModal>
  );
};

export default PublicInfoModal;
